import { makeStyles } from "@material-ui/core/styles";

export const clausesStyles = makeStyles((theme) => ({
  paper: {
    position: "relative",
    width: 500,
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.24)",
    outline: "none",
    borderRadius: 8,
    padding: theme.spacing(2, 4, 3),
  },
  accept: {
    background: "#E5E5E5",
    color: "#7EBDCE",
    marginRight: "5%",
    "&:hover": {
      background: "#E5E5E5",
    },
  },
  cancel: {
    background: "#7EBDCE",
    color: "white",
    "&:hover": {
      background: "#7EBDCE",
    },
  },
  text: {
    fontSize: 15,
    fontFamily: "Roboto",
    color: "#545353",
    textAlign: "center",
    margin: "25px 20px",
  },
  titleAlert: {
    fontSize: 24,
    textAlign: "center",
    fontFamily: "Roboto",
    fontWeight: "bold",
    color: "#545353",
  },
  titleCreate: {
    fontFamily: "Roboto",
    fontSize: 24,
    fontStyle: "normal",
    fontWeight: "normal",
    letterSpacing: "0em",
    textAlign: "left",
    marginBottom: 32,
  },
}));
